// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`OfferGroup test Match con el snapshot 1`] = `""`;
